import { format } from "date-fns";

export default function formatDate(d: Date, withTime = false): string {  
  return withTime ? format(d, "yyyy-MM-dd HH:mm") : format(d, "yyyy-MM-dd");
}
